import { to_array } from "./to_array"

export const length = a => to_array(a).length
